export default __webpack_public_path__ + "static/media/e-met-logotype-d.150aed63.svg";